const initialState = {
    entity: {
        payload: null,
        error: null,
        fetched: false,
        fetching: false
    },
    tokenList: {
        payload: null,
        map: [],
        error: null,
        fetched: false,
        fetching: false,
        page: 1,
        pageSize: process.env.PAGE_SIZE || 10,
        totalElements: 0,
        totalPages: 0
    },
    payment: {
        payload: null,
        error: null,
        fetched: false,
        fetching: false
    }
}

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_USER_PENDING": {
            return {
                ...state,
                entity: {
                    payload: null,
                    error: null,
                    fetched: false,
                    fetching: true
                }
            }
        }
        case "FETCH_USER_REJECTED": {
            return {
                ...state,
                entity: {
                    payload: null,
                    error: action.payload,
                    fetched: false,
                    fetching: false
                }
            }
        }
        case "FETCH_USER_FULFILLED": {
            action.payload = null
            return {
                ...state,
                entity: {
                    payload: action.payload,
                    error: null,
                    fetched: true,
                    fetching: false
                }
            }
        }
        case "GET_TOKEN_DETAILS_REJECTED": {
            return {
                ...state,
                entity: {
                    ...state.entity,
                    payload: null,
                    error: null,
                    fetched: false,
                    fetching: false
                }
            }
        }
        case "GET_TOKEN_DETAILS_FULFILLED": {
            action.payload.data.payload.value= null
            return {
                ...state,
                entity: {
                    ...state.entity,
                    payload: action.payload.data.payload,
                    error: null,
                    fetched: true,
                    fetching: false
                }
            }
        }

        case "GET_TOKEN_LIST_PENDING": {
            return {
                ...state,
                tokenList: {
                    ...state.list,
                    payload: null,
                    error: null,
                    fetched: false,
                    fetching: true
                }
            }
        }

        case "GET_TOKEN_LIST_FULFILLED": {
            return {
                ...state,
                tokenList: {
                    ...state.list,
                    payload: action.payload.data,
                    error: null,
                    fetched: true,
                    fetching: false,
                    totalElements: action.payload.headers['x-meta-total-elements'],
                    totalPages: action.payload.headers['x-meta-total-pages']
                }
            }
        }
        case "GET_TOKEN_LIST_REJECTED": {
            return {
                ...state,
                tokenList: {
                    ...state.list,
                    payload: null,
                    error: action.payload.data,
                    fetched: false,
                    fetching: false
                }
            }
        }

        case "SUBMIT_PAYMENT_PENDING": {
            return {
                ...state,
                payment: {
                    payload: null,
                    error: null,
                    fetched: false,
                    fetching: true
                }
            }
        }
        case "SUBMIT_PAYMENT_REJECTED": {
            return {
                ...state,
                payment: {
                    payload: null,
                    error: action.payload,
                    fetched: false,
                    fetching: false
                }
            }
        }
        case "SUBMIT_PAYMENT_FULFILLED": {
            action.payload = null
            return {
                ...state,
                payment: {
                    payload: action.payload,
                    error: null,
                    fetched: true,
                    fetching: false
                }
            }
        }


        case "LOGOUT_PENDING":
            return state

        case "LOGOUT_FULFILLED":
            return initialState

        case "LOGOUT_REJECTED":
            return state


        default : {
            return state
        }
    }
}